import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link, { LinkProps } from '@mui/material/Link';
import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AuthContext } from '../../common/Auth';
import { useThemeSettings } from '../../layouts/state/useThemeSettings';
import { BreadCrumbItem } from '../../models/BreadCrumb';

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
  isLastElement?: boolean;
}

function LinkRouter(props: Readonly<LinkRouterProps>) {
  return (
    <Link
      {...props}
      style={{ fontWeight: props.isLastElement ? 600 : 400 }}
      component={props.isLastElement ? 'span' : (RouterLink as any)}
    />
  );
}

type BreadCrumbStyle = {
  breadCrumbFontColor?: string;
  breadCrumbFontSize?: number;
  breadCrumbFont?: string;
  breadCrumbBackgroundColor?: string;
  breadCrumbHoverColor?: string;
  showBreadCrumbs?: boolean;
};

interface MuiBreadcrumbProps {
  breadCrumbData?: BreadCrumbItem[];
}

export default function MuiBreadcrumb({ breadCrumbData }: Readonly<MuiBreadcrumbProps>) {
  const { settingData } = useContext(AuthContext);
  const [showBreadCrumbs, setShowBreadCrumbs] = useState<boolean>();
  const [breadCrumbStyle, setBreadCrumbStyle] = useState<BreadCrumbStyle>({});
  const { generalSettings } = useThemeSettings({ settingData });
  const styles = {
    color: breadCrumbStyle?.breadCrumbFontColor ?? '#5b5858',
    fontSize: (breadCrumbStyle?.breadCrumbFontSize ?? '15') + 'px',
    fontFamily: breadCrumbStyle?.breadCrumbFont ?? 'Poppins, sans-serif',
    breadCrumbHoverColor: breadCrumbStyle?.breadCrumbHoverColor ?? '#5b58aa',
    justifyContent: 'center',
    display: 'flex',
  };

  const bgStyles = {
    backgroundColor: breadCrumbStyle?.breadCrumbBackgroundColor
      ? breadCrumbStyle?.breadCrumbBackgroundColor
      : '#f7f7f7',
  };

  useEffect(() => {
    if (generalSettings) {
      const { values = {} } = generalSettings || {};
      const breadCrumbValues = values as BreadCrumbStyle;
      setBreadCrumbStyle(breadCrumbValues);
      setShowBreadCrumbs(breadCrumbValues?.showBreadCrumbs);
    }
  }, [generalSettings]);

  return (
    <div>
      {showBreadCrumbs && (
        <div className="breadcrumb-area pt-15 pb-15 bg-gray-3" style={bgStyles}>
          <div className="container breadcrumb-content text-center">
            <Breadcrumbs aria-label="breadcrumb" style={styles}>
              {breadCrumbData?.map((item, index) => {
                const isLastElement = index === breadCrumbData.length - 1;
                return (
                  <LinkRouter
                    key={index}
                    isLastElement={isLastElement}
                    underline="none"
                    color="inherit"
                    sx={{ '&:hover': { color: isLastElement ? '' : styles.breadCrumbHoverColor } }}
                    to={item.path ?? '/'}
                  >
                    {item.name?.toUpperCase()}
                  </LinkRouter>
                );
              })}
            </Breadcrumbs>
          </div>
        </div>
      )}
    </div>
  );
}
